const BALLET_PATH = location.origin + "/art-college/ballet",
      ASSETS_PATH = BALLET_PATH + "/assets",
      DEFAULT_STUDIO_REAGION = "tyo";
const getQuery = () => {
  const queries = location.search.substr(1).replace("#","").split("&");
  let query = {};
  for (let i = queries.length - 1; i >= 0; i--) {
    let q = queries[i].split("=");
    query[q[0]] = q[1];
  }
  return query;
}
const sortRecords = (response, order, num) => {
  const compare = (a, b) => {
    if(order==="desc"){
      return (a.num > b.num) ? -1 : 1;      
    } else {
      return (a.num < b.num) ? -1 : 1;
    }
  }
  const sort = response.data.sort(compare);
  const records = (num) ? sort.slice(0, num) : sort;

  return records;
}
const getCookie = ((d) => {
  const cookie_items = d.cookie.split(";");
  let cookie = {};
  for (let i = cookie_items.length - 1; i >= 0; i--) {
    let cookie_attrs = cookie_items[i].split("=");
    if(cookie_attrs.length < 2){continue;}
    cookie[cookie_attrs[0].trim()] = cookie_attrs[1].trim();
  }
  return cookie;
})(document)
const formatNum2Str = (num, exp) => {
  const n = Number(num);
  let str = "";
  if (!exp || exp.length <= 0) {
    return String(n);
  }
  for (let i = exp.length - String(n).length - 1; i >= 0; i--) { 
    str += "0";
  }
  return str + n;
}

const setAccordion = () => {
  const d = document,
        selector = ".js-accordion",
        accordions = d.querySelectorAll(selector);
  let triggerId;

  function toggle(ev) {
    const href = this.getAttribute("href"),
          active = d.getElementById(href.substr(1));
    triggerId = href;
    set(this.closest(selector));
    active.classList.toggle("is-active");
    ev.preventDefault();
  }  
  const set = (el, init) => {
    const items = el.querySelectorAll(selector + "__itm");
    if (items.length === 0) {
      return false;
    }
    for (let i = items.length - 1; i >= 0; i--) {
      let trigger = items[i].querySelector(selector + "__trigger"),
          target = items[i].querySelector(selector + "__target");
          
      if (triggerId !== trigger.getAttribute("href")) {
        items[i].classList.remove("is-active");        
      }
      if (init) {
        target.style.marginTop = -target.clientHeight + "px";
        trigger.addEventListener("click", toggle);       
      }
    }
  }
  if (accordions.length === 0) {
    return false;
  }
  for (let i = accordions.length - 1; i >= 0; i--) {
    set(accordions[i],true);
  }
}

/* ペンディング箇所を可視化するためのスクリプト */
const displayPendhingNode = () => { 
  const d = document,
    pendingNodes = d.querySelectorAll("[data-pending]");
  let pendingText;
  for (let i = pendingNodes.length - 1; i >= 0; i--) {
    pendingText = d.createElement("p");
    pendingText.classList.add("pending-txt");
    pendingNodes[i].classList.add("is-pending");
    if (pendingNodes[i].dataset.height) {
      pendingNodes[i].style.height = pendingNodes[i].dataset.height;      
    }
    pendingText.innerText = pendingNodes[i].dataset.pending;
    pendingNodes[i].appendChild(pendingText);
  }
}

const getCurPos = () => {
  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };
  return new Promise( (resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options);    
  });
}

const getDistance = (lat1, lng1, lat2, lng2) => {
  function radians(deg){
    return deg * Math.PI / 180;
  }
  return 6378.14 * Math.acos(
    Math.cos(radians(lat1)) *
    Math.cos(radians(lat2)) *
    Math.cos(radians(lng2) - radians(lng1)) +
    Math.sin(radians(lat1)) *
    Math.sin(radians(lat2))
  );
}

const matches = (elem, selector) => {
  var method = Element.prototype.matches
             || Element.prototype.msMatchesSelector
             || Element.prototype.webkitMatchesSelector;
  return method.call(elem, selector);
}

const closest = (elem, selector) => {
  do {
    if (matches(elem, selector)) return elem;
    elem = elem.parentElement || elem.parentNode;
  } while (elem !== null && elem.nodeType === 1);
  return null;
}

/* common DOM traverse or manipulate or listen method */
const delegate = (elem, selector, event, fn) => {
  elem.addEventListener(event, function (e) {
    const target = closest(e.target, selector);
    if (target != null) {
      fn.call(target, e);
    }
  })
}

export default {
  BALLET_PATH: BALLET_PATH,
  ASSETS_PATH: ASSETS_PATH,
  DEFAULT_STUDIO_REAGION: DEFAULT_STUDIO_REAGION,
  getQuery: getQuery,
  sortRecords: sortRecords,
  displayPendhingNode: displayPendhingNode,
  getCookie: getCookie,
  formatNum2Str: formatNum2Str,
  setAccordion: setAccordion,
  getCurPos: getCurPos,
  getDistance: getDistance,
  delegate: delegate,
  matches: matches,
  closest: closest
}